(() => {
const dismissed = new Set();
let cursorOrigin = null;
function moveCampaignCursor(target) {
const cursor = document.getElementById('lux-cursor');
if (!cursor) return;
try {
if (typeof cursor.hidePopover === 'function' && cursor.matches(':popover-open')) cursor.hidePopover();
target.appendChild(cursor);
if (typeof cursor.showPopover === 'function') cursor.showPopover();
} catch {}
}
const termsDialog = document.getElementById('kiara-campaign-terms');
if (termsDialog) {
termsDialog.addEventListener('close', () => {
if (cursorOrigin && cursorOrigin.isConnected) moveCampaignCursor(cursorOrigin);
cursorOrigin = null;
});
termsDialog.addEventListener('click', event => {
if (event.target !== termsDialog) return;
const r = termsDialog.getBoundingClientRect();
if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) termsDialog.close();
});
}
const feedbackTimers = new WeakMap();
function update() {
const active = window.kiaraCampaignIsActive && window.kiaraCampaignIsActive();
document.querySelectorAll('[data-kc-placement]').forEach(el => { el.hidden = !active || dismissed.has(el); });
const dialog = document.querySelector('[data-kc-popup]');
if (!active && termsDialog && termsDialog.open) termsDialog.close();
if (!active && dialog) { if (dialog.open) dialog.close(); dialog.hidden = true; }
}
async function writeClipboard(value) {
if (navigator.clipboard && navigator.clipboard.writeText) {
try { await navigator.clipboard.writeText(value); return; } catch {}
}
const field = document.createElement('textarea');
field.value = value; field.readOnly = true;
field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
document.body.appendChild(field);
field.select();
let copied = false;
try { copied = document.execCommand('copy'); } finally { field.remove(); }
if (!copied) throw new Error('Unable to copy');
}
document.addEventListener('click', async event => {
const termsTrigger = event.target.closest('[data-kc-terms-open]');
if (termsTrigger && termsDialog && !termsDialog.open) {
cursorOrigin = document.getElementById('lux-cursor')?.parentNode;
termsDialog.showModal();
moveCampaignCursor(termsDialog);
}
const close = event.target.closest('[data-kc-dismiss]');
if (close) { const bar=close.closest('[data-kc-bar]'); dismissed.add(bar); update(); }
const button = event.target.closest('[data-kc-copy]');
if (!button) return;
const control = button.closest('[data-kc-code]');
const status = control.querySelector('[data-kc-copy-status]');
try {
await writeClipboard(control.querySelector('[data-kc-code-value]').textContent.trim());
status.textContent = 'Discount code copied';
} catch { status.textContent = 'Select the code to copy manually'; }
clearTimeout(feedbackTimers.get(control));
status.classList.add('is-visible');
feedbackTimers.set(control,setTimeout(()=>{status.classList.remove('is-visible');status.textContent='';},2200));
});
window.addEventListener('pageshow', () => { dismissed.clear(); update(); });
update();
setInterval(update, 1000);
document.addEventListener('visibilitychange', update);
})();